import { AnnotateSVG, Icon } from "@newsela/angelou";
import { Editor } from "@tiptap/react";

import useAnnotationsState from "@/view/utils/useAnnotationsState";
import BaseTextSelectionMenu from "../BaseTextSelectionMenu";
import { iconCss } from "./AnnotationsTextSelectionMenu.style";
import { getAnnotationsClickHandler } from "./utils";

interface AnnotationsTextSelectionMenuProps {
  editor: Editor;
}

const AnnotationsTextSelectionMenu = ({
  editor,
}: AnnotationsTextSelectionMenuProps) => {
  const { setDraftAnnotation, focusAnnotationCard } = useAnnotationsState();

  const title = "Annotation";
  const onClick = getAnnotationsClickHandler(
    editor,
    setDraftAnnotation,
    focusAnnotationCard,
  );
  const icon = (
    /* @ts-ignore: AnnotateIcon is not typed */
    <Icon SvgComponent={AnnotateSVG} size={Icon.sizes.sm} __cssFor={iconCss} />
  );

  return (
    <BaseTextSelectionMenu
      editor={editor}
      title={title}
      onClick={onClick}
      icon={icon}
      dataTestId="AnnotationsTextSelectionMenu"
    />
  );
};

export default AnnotationsTextSelectionMenu;
